import { FiSearch } from 'react-icons/fi';

interface SearchFilterProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
}

const SearchFilter = ({
    value = '',
    onChange,
    placeholder = "Buscar...",
    className = ''
}: SearchFilterProps) => {
    if (!onChange) return null;

    return (
        <div className={`relative ${className}`}>
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" size={16} />
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-slate-600 rounded-lg 
                         bg-white dark:bg-slate-800 text-gray-900 dark:text-white
                         focus:ring-2 focus:ring-blue-500 focus:border-transparent
                         placeholder-gray-500 dark:placeholder-gray-400"
            />
        </div>
    );
};

export default SearchFilter;
